import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DeleteVideoResponse, PresignPutResponse, VideoListResponse, VideoUrlResponse } from '../models/video';

@Injectable({
  providedIn: 'root'
})
export class VideosService {
  private readonly listUrl = `${environment.BASE_URL}${environment.BASE_API.VIDEO_LIST}`;
  private readonly videoBase = `${environment.BASE_URL}${environment.BASE_API.VIDEO}`;

  constructor(private http: HttpClient) {}

  listVideos(prefix?: string): Observable<VideoListResponse> {
    if (prefix) {
      return this.http.get<VideoListResponse>(this.listUrl, { params: { prefix } });
    }
    return this.http.get<VideoListResponse>(this.listUrl);
  }

  getVideoUrl(videoKey: string): Observable<VideoUrlResponse> {
    const url = `${this.videoBase}/${encodeURIComponent(videoKey)}`;
    return this.http.get<VideoUrlResponse>(url);
  }

  getPresignedUrl(videoKey: string): Observable<string> {
    return this.getVideoUrl(videoKey).pipe(
      map((resp) => resp?.body?.url as string)
    );
  }

  presignUploadNew(key: string, contentType?: string): Observable<PresignPutResponse> {
    const payload: any = { key };
    if (contentType) payload.content_type = contentType;
    return this.http.post<PresignPutResponse>(this.videoBase, payload);
  }

  presignUploadExisting(key: string, contentType?: string): Observable<PresignPutResponse> {
    if (contentType) {
      return this.http.put<PresignPutResponse>(
        `${this.videoBase}/${encodeURIComponent(key)}`,
        null,
        { params: { content_type: contentType } }
      );
    }
    return this.http.put<PresignPutResponse>(`${this.videoBase}/${encodeURIComponent(key)}`, null);
  }

  deleteVideo(key: string): Observable<DeleteVideoResponse> {
    return this.http.delete<DeleteVideoResponse>(`${this.videoBase}/${encodeURIComponent(key)}`);
  }
}


